export interface ControleCaixaParametrosModel {
  incluirTroco: boolean;
  contaCaixa: boolean;
  fechamentoCego: boolean;
}

export interface ControleCaixaSessaoModel {
  idPdvCaixa: number;
  pdv: string;
  operador: string;
  status: 'ABERTO' | 'FECHADO';
  troco: number;
}

export interface ControleCaixaFormaTotalModel {
  formaPagamento: string;
  total: number;
}

export interface ControleCaixaVendasModel {
  formas: ControleCaixaFormaTotalModel[];
  total: number;
}

export interface ControleCaixaPendenteModel {
  idPedidoVenda: number;
  cliente: string;
  formaPagamento: string;
  data: string;
  hora: string;
  valor: number;
}

export interface ControleCaixaRecebimentoModel {
  idPdvRecebimento: number;
  data: string;
  hora: string;
  cliente: string;
  total: number;
}

export interface ControleCaixaDevolucaoModel {
  idPedidoVenda: number;
  data: string;
  hora: string;
  cliente: string;
  credito: number | null;
}

export interface ControleCaixaCancelamentoModel {
  idPedidoVenda: number;
  data: string;
  hora: string;
  cliente: string;
  valor: number;
}

export interface ControleCaixaCreditoModel {
  data: string;
  origem: string;
  devolucao: string;
  valor: number;
}

export interface ControleCaixaMovimentoLinhaModel {
  data: string;
  hora: string;
  formaPagamento: string;
  descricao: string;
  valor: number;
}

export interface ControleCaixaMovimentosModel {
  suprimentos: ControleCaixaMovimentoLinhaModel[];
  sangrias: ControleCaixaMovimentoLinhaModel[];
}

export interface ControleCaixaPaginacaoItemModel {
  pagina: number;
  porPagina: number;
  totalItens: number;
  totalPaginas: number;
}

export interface ControleCaixaPaginacaoModel {
  vendas: ControleCaixaPaginacaoItemModel;
  pendentes: ControleCaixaPaginacaoItemModel;
  recebimentos: ControleCaixaPaginacaoItemModel;
  devolucoes: ControleCaixaPaginacaoItemModel;
  cancelamentos: ControleCaixaPaginacaoItemModel;
  creditos: ControleCaixaPaginacaoItemModel;
  suprimentos: ControleCaixaPaginacaoItemModel;
  sangrias: ControleCaixaPaginacaoItemModel;
}

/** Full Controle de Caixa package — ERP Caixa tabs, read-only. */
export class ControleCaixaModel {
  sessao?: ControleCaixaSessaoModel;
  parametros: ControleCaixaParametrosModel;
  vendas: ControleCaixaVendasModel;
  pendentes: ControleCaixaPendenteModel[];
  recebimentos: ControleCaixaRecebimentoModel[];
  devolucoes: ControleCaixaDevolucaoModel[];
  cancelamentos: ControleCaixaCancelamentoModel[];
  creditos: ControleCaixaCreditoModel[];
  movimentos: ControleCaixaMovimentosModel;
  paginacao: ControleCaixaPaginacaoModel;
}

export function emptyControleCaixa(): ControleCaixaModel {
  return {
    parametros: { incluirTroco: true, contaCaixa: true, fechamentoCego: false },
    vendas: { formas: [], total: 0 },
    pendentes: [],
    recebimentos: [],
    devolucoes: [],
    cancelamentos: [],
    creditos: [],
    movimentos: { suprimentos: [], sangrias: [] },
    paginacao: {
      vendas: { pagina: 1, porPagina: 15, totalItens: 0, totalPaginas: 1 },
      pendentes: { pagina: 1, porPagina: 15, totalItens: 0, totalPaginas: 1 },
      recebimentos: { pagina: 1, porPagina: 15, totalItens: 0, totalPaginas: 1 },
      devolucoes: { pagina: 1, porPagina: 15, totalItens: 0, totalPaginas: 1 },
      cancelamentos: { pagina: 1, porPagina: 15, totalItens: 0, totalPaginas: 1 },
      creditos: { pagina: 1, porPagina: 15, totalItens: 0, totalPaginas: 1 },
      suprimentos: { pagina: 1, porPagina: 15, totalItens: 0, totalPaginas: 1 },
      sangrias: { pagina: 1, porPagina: 15, totalItens: 0, totalPaginas: 1 },
    },
  };
}
